module.exports = "img/11.a6e570.webp";